import {MemberDto, MemberDtoInvitationStatusEnum} from "../../generated/account-client";
import {useState} from "react";
import {Button, Dropdown, Menu} from "antd";
import { MenuInfo } from "rc-menu/lib/interface";
import {EllipsisOutlined} from "@ant-design/icons";
import RemoveUserModal from "./modal/RemoveUserModal";

export interface TeamPermissionsDropdownProps {
  member: MemberDto;
  onRevoke: (member: MemberDto) => void;
  onResend: (member: MemberDto) => void;
  onRemove: (member: MemberDto) => void;
}

export default function TeamPermissionsDropdown({member, onResend, onRevoke, onRemove}: TeamPermissionsDropdownProps) {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [showRemoveUserModal, setShowRemoveUserModal] = useState(false);

  const toggleDropdown = (info: MenuInfo) => {
    info.domEvent.stopPropagation();
    info.domEvent.preventDefault();
    switch (+info.key) {
      case 0:
        setIsDropdownVisible(false);
        onResend(member);
        return;
      case 1:
        setIsDropdownVisible(false);
        setShowRemoveUserModal(true);
        return;
      case 2:
        setIsDropdownVisible(false);
        return;
      case 3:
        setIsDropdownVisible(false);
        setShowRemoveUserModal(true);
        return;
    }
  };

  const menu = (
    <Menu className={"is-primary-menu"} onClick={toggleDropdown}>
      <Menu.Item key="0">Resend Invitation</Menu.Item>
      <Menu.Item key="1">Cancel Invitation</Menu.Item>
    </Menu>
  );

  const menuActiveUser = (
    <Menu className={"is-primary-menu"} onClick={toggleDropdown}>
      <Menu.Item key="3">Remove Access</Menu.Item>
    </Menu>
  );

  return <>
    <Dropdown
      placement="bottomRight"
      arrow={false}
      visible={isDropdownVisible}
      className={"card-dropdown"}
      overlay={
        member.invitationStatus === MemberDtoInvitationStatusEnum.Active
          ? menuActiveUser
          : menu
      }
      trigger={["click"]} 
      onVisibleChange={() => setIsDropdownVisible(!isDropdownVisible)}
    >
      <Button id={member.id} size={"small"}>
        <EllipsisOutlined />
      </Button>
    </Dropdown>

    <RemoveUserModal
      member={member}
      visible={showRemoveUserModal}
      onCancel={() => setShowRemoveUserModal(false)}
      onRemove={
        member.invitationStatus === MemberDtoInvitationStatusEnum.Active
          ? onRemove
          : onRevoke
      }
    />
  </>
}
